<template>
  <div v-show="!routeParamId">
    <div class="row">
      <div class="home-nav-container p-0 col-lg-3 col-xl-2 h-100 d-none d-lg-block">
        <scrollactive
          class="home-nav"
          active-class="active"
          highlight-first-item
          :offset="360"
          :duration="600"
          bezier-easing-value=".5,0,0.90,1"
          @itemchanged="onItemChanged"
        >
          <ul
            class="scroll-list hide-on-small-height"
            :class="setTop20 ? 'top-20': setBottom20 ? 'bottom-20':''"
          >
            <li v-for="(item, index) in topLevelSections" :key="item.id">
              <a
                :href="'/apps/new-guides/'+ applicationAlias + '#' + item.jumpLink"
                class="scrollactive-item"
                v-bind:class="[index === 0 ? 'active' : '']"
                @click="trackJumpLinkChanges(item)"
              >{{ item.name }}</a>
            </li>
          </ul>
        </scrollactive>
      </div>

      <div class="col-lg-8 offset-xl-1 p-0 col-12-on-small-height">
        <div
          v-for="item in topLevelSections"
          :id="item.jumpLink"
          :key="item.id"
          data-aos="fade-up"
          data-aos-duration="800"
          class="mb-5 pt-5"
        >
          <carousel-branch v-if="isCarouselBranch(item)" :sectionId="item.id"></carousel-branch>
          <standard-branch v-else :sectionId="item.id"></standard-branch>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueScrollTo from "vue-scrollto";
import AOS from "aos";
import "aos/dist/aos.css";
import { mapGetters, mapActions } from "vuex";
import CarouselBranch from "@/components/homepage/CarouselBranch";
import StandardBranch from "@/components/homepage/StandardBranch";
import Constants from "../../store/constants";

AOS.init();
Vue.use(VueScrollTo);
export default {
  components: {
    CarouselBranch,
    StandardBranch
  },
  data() {
    return {
      Constants,
      setTop20: false,
      setBottom20: false,
      NAV_END_THRESHOLD_HEIGHT: 6000,
      NAV_START_THRESHOLD_HEIGHT: 100,
      applicationAlias: null
    };
  },
  mounted() {
    this.navigateToHash();
    this.scrollHomepageLeftNav();
    this.getApplicationAlias();
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.handleHomePageScroll);
  },
  methods: {
    ...mapActions(["fetchDecisionBranches"]),
    ...mapActions(["getAppData"]),
    scrollHomepageLeftNav() {
      document.addEventListener("scroll", this.handleHomePageScroll);
    },
    handleHomePageScroll() {
      let scrollPercent = window.pageYOffset;
      this.setTop20 =
        scrollPercent > this.NAV_START_THRESHOLD_HEIGHT &&
        scrollPercent < this.NAV_END_THRESHOLD_HEIGHT;
      this.setBottom20 = scrollPercent > this.NAV_END_THRESHOLD_HEIGHT;
    },
    isCarouselBranch(item) {
      return item.displayType === "Carousel";
    },
    navigateToHash() {
      let that = this;
      if (that.$route.hash) {
        let hash = that.$route.hash;
        if (!hash || hash === "#" || hash === "#/") {
          window.scrollTo(0, 0);
          return;
        }

        let attrName = hash.replace("#", "");
        var attrId = this.getParentSectionId(attrName);

        this.decisionBranches.sections.forEach(section => {
          var sectionElement = $(`a[href*='#${section.id}']`)
          if(sectionElement[0] && sectionElement[0].classList) {
            sectionElement[0].classList.remove("active")
          }
        })
        var matchingElements = $(`a[href*='${hash}']`)
        if(matchingElements){
          if(matchingElements[0] && matchingElements[0].classList) {
            matchingElements[0].classList.add("active");
          }
        }
        var attrHashId = attrId ? attrId : attrName;
        const hashAttr = document.querySelector(`#${CSS.escape(attrHashId)}`);
        that.$scrollTo(hashAttr, 600, {
          easing: "linear"
        });
      }
    },
    onItemChanged(event, currentItem, lastActiveItem) {
      let topLevelItems = JSON.parse(JSON.stringify(this.topLevelSections));
      topLevelItems.sort((a, b) => a.ehOrder - b.ehOrder);
    },
    trackJumpLinkChanges(item) {
      let event = this.currentAppData
        ? this.currentAppData.name + " Home - side nav selected"
        : "Home - side nav selected";
      let subEvent = item.name;
      this.$hhMixpanel.trackEvent(event, { subEvent: subEvent });
    },
    async loadDecisionBranches() {
      await this.fetchDecisionBranches();
    },
    getApplicationAlias() {
      this.applicationAlias = this.currentAlias;
    },
    getParentSectionId(childSectionId) {
      let parentSectionId;
      if (this.allCategories) {
        this.allCategories.forEach(category => {
          if (category.parentCategoryId && category.id === childSectionId) {
            parentSectionId = category.parentCategoryId;
          }
        });
      }
      return parentSectionId;
    }
  },
  created() {
    this.loadDecisionBranches();
  },
  computed: {
    routeParamId() {
      return this.$route.params && this.$route.params.id;
    },
    ...mapGetters([
      "decisionBranches",
      "isLoading",
      "currentAppData",
      "currentAlias",
      "allCategories"
    ]),
    topLevelSections() {
      return this.decisionBranches.sections
        .filter(item => !item.parent)
        .sort((a, b) => a.ehOrder - b.ehOrder);
    }
  }
};
</script>

<style scoped>
.top-20 {
  position: fixed;
  top: 20rem;
}

.bottom-20 {
  position: fixed;
  bottom: 20rem;
}

@media screen and (max-height: 680px) {
  .hide-on-small-height {
    display: none;
  }

  .col-12-on-small-height {
    margin-left: 0 !important;
    -ms-flex: 0 0 100% !important;
    -webkit-box-flex: 0 !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>
<style>
/* Hide in ipad pro screen size*/
@media (max-width: 900px) {
  .home-nav-container {
    visibility: hidden;
  }
}

.home-nav {
  font-size: 16px;
  color: #000;
}

.scroll-list {
  list-style-type: none;
  padding-inline-start: 0;
  width: 200px;
  font-size: 16px !important;
  font-family: artifaktElementBold !important;
}

@media (max-width: 1280px) {
  .scroll-list {
    width: 300px;
  }
}

.scroll-list li {
  margin-bottom: 15px;
  display: flex;
}

.scroll-list li a {
  padding-left: 15px;
}

.active {
  color: #5f60ff !important;
  font-weight: 700;
  font-size: 16px;
  border-left: 5px solid;
  font-family: artifaktElementBold;
  cursor: pointer;
}

.child-title {
  font-size: 18px;
  color: #000;
  font-family: artifaktElementBoldHH;
  text-align: left !important;
}

.child-card {
  height: 300px;
}

.card-header {
  background: #fff !important;
  border: none;
  border-bottom: none !important;
}

.card-link {
  font-size: 14px;
  font-weight: 700;
  color: black !important;
}

.action-lnk {
  text-decoration: none;
  color: #000;
}

.scrollactive-item {
  font-weight: 700;
  color: #000000 !important;
}

.scrollactive-item.active {
  color: #5f60ff !important;
}

.support {
  padding-left: 820px;
  font-size: 18px;
  position: relative;
}
</style>